import React, { useEffect, useState } from "react";
import { Modal } from "antd";

import LeadForm from "./LeadForm";

const CreateNewLead = ({ openModal, setShowAddLeadModal, initialValues }) => {
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShowModal(openModal);
  }, [openModal]);

  const closeModal = () => {
    setShowModal(false);
    setShowAddLeadModal(false);
  };

  return (
    <Modal
      title={null}
      width="650px"
      open={showModal}
      onCancel={closeModal}
      className="delete-popup"
      confirmLoading={loading}
      footer={false}
    >
      <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-lg tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50">
        Create New Lead
      </div>
      <div className="mt20">
        <LeadForm isNewLead setLoading={setLoading} closeModal={closeModal} initialValues={initialValues} />
      </div>
    </Modal>
  );
};

export default CreateNewLead;
